export default __webpack_public_path__ + "static/media/sports_rugby.78fe75f3.svg";